import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBA7_huy-_M3HS5m9hdk1dtCs5lioVG-PY',
    libraries: 'geometry',
    // Eg: libraries: 'places,drawing'
    // Eg: libraries: 'places,drawing,visualization'
    // (as you require)
  },
});

Vue.$gmapApiPromiseLazy().then((google) => {
  // eslint-disable-next-line
  google.maps.Map.prototype.panToWithOffset = function (latlng, offsetX, offsetY) {
    const map = this;
    const ov = new google.maps.OverlayView();
    ov.onAdd = () => {
      const projection = this.getProjection();
      const aPoint = projection.fromLatLngToContainerPixel(latlng);
      aPoint.x += offsetX;
      aPoint.y += offsetY;
      map.panTo(projection.fromContainerPixelToLatLng(aPoint));
    };
    ov.draw = () => {};
    ov.setMap(this);
  };
});
